(function () {
    function initHomeOfferSlider(sectionElement) {
        if (!sectionElement || sectionElement.dataset.homeOfferInitialized === 'true') {
            return;
        }

        var sliderElement = sectionElement.querySelector('[data-home-offer-swiper]');

        if (!sliderElement) {
            return;
        }

        var slides = Array.prototype.slice.call(sliderElement.querySelectorAll('.vitalify-home-offer__slide'));

        sectionElement.dataset.homeOfferInitialized = 'true';

        if (!slides.length) {
            return;
        }

        sliderElement.dataset.offerFadeReady = 'true';

        var activeIndex = 0;
        var delay = 8500;
        var timer = null;
        var previousButton = sectionElement.querySelector('[data-home-offer-prev]');
        var nextButton = sectionElement.querySelector('[data-home-offer-next]');

        function setActiveSlide(nextIndex) {
            activeIndex = (nextIndex + slides.length) % slides.length;

            slides.forEach(function (slide, index) {
                var isActive = index === activeIndex;

                slide.classList.toggle('is-active', isActive);
                slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
            });
        }

        function stopTimer() {
            if (timer) {
                window.clearInterval(timer);
                timer = null;
            }
        }

        function startTimer() {
            stopTimer();

            if (slides.length <= 1) {
                return;
            }

            timer = window.setInterval(function () {
                setActiveSlide(activeIndex + 1);
            }, delay);
        }

        function goToSlide(nextIndex) {
            setActiveSlide(nextIndex);
            startTimer();
        }

        setActiveSlide(0);
        startTimer();

        if (previousButton) {
            previousButton.addEventListener('click', function () {
                goToSlide(activeIndex - 1);
            });
        }

        if (nextButton) {
            nextButton.addEventListener('click', function () {
                goToSlide(activeIndex + 1);
            });
        }

        sectionElement.addEventListener('mouseenter', stopTimer);
        sectionElement.addEventListener('mouseleave', startTimer);
    }

    window.VitalifyHomeOfferBanner = {
        init: initHomeOfferSlider
    };
})();
